(function() {
  'use strict';

  createLightbox();
  bindZoomIcons();

  function createLightbox() {
    if (document.getElementById('custom-color-lightbox-v2')) return;
    const overlay = document.createElement('div');
    overlay.id = 'custom-color-lightbox-v2';
    overlay.className = 'custom-lightbox-overlay-v2';
    overlay.innerHTML = `
      <div class="custom-lightbox-content-v2">
        <button class="custom-lightbox-close-v2" aria-label="closed">&times;</button>
        <img src="" alt="">
      </div>
    `;
    document.body.appendChild(overlay);

    overlay.querySelector('.custom-lightbox-close-v2').addEventListener('click', hideLightbox);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) hideLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') hideLightbox();
    });
  }

  function bindZoomIcons() {
    document.addEventListener('click', function(e) {
      const zoomIcon = e.target.closest('.custom-color-zoom-icon-v2');
      if (!zoomIcon) return;
      e.preventDefault();
      e.stopPropagation();
      const imgSrc = zoomIcon.getAttribute('data-zoom-image');
      if (imgSrc) showLightbox(imgSrc);
    });
  }

  function showLightbox(imgSrc) {
    const overlay = document.getElementById('custom-color-lightbox-v2');
    if (!overlay) return;
    overlay.querySelector('img').src = imgSrc;
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function hideLightbox() {
    const overlay = document.getElementById('custom-color-lightbox-v2');
    if (!overlay) return;
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
})();